import request from '@/config/mixin/server'
import {BASEURL_PRO} from '@/modules/http.js'
// export function login(data) {
//   return request({
//     url: '/vue-admin-template/user/login',
//     method: 'post',
//     data
//   })
// }

// 获取验证码
export function getCodeImg() {
  return request({
    url: `${BASEURL_PRO}/union/CaptchaBase64`,
    method: "get",
    
    withCredentials: true,
  });
}


// WEBPACK FOOTER //
// ./src/api/imgCode.js